<template>
    <v-container fluid class="pt-0">
        <v-row align="start" justify="center">
            <v-col cols="12" md="12" sm="12">
                <v-card class="elevation-4">
                    <v-card-title>
                        {{$t('zz_course_list')}}
                        <div class="flex-grow-1"></div>
                        <v-text-field
                        v-model="search"
                        append-icon="search"
                        :label="$t('zz_search')"
                        single-line
                        hide-details
                        ></v-text-field>
                        <v-btn color="primary" class="ml-3" @click="$router.push({name:'createcourse'})">{{$t('zz_create_course')}}</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-divider></v-divider>
                        <v-data-table
                            :headers="headers"
                            :items="idtypes"
                            :items-per-page="20"
                            :search="search"
                            class="elevation-1">

                            <template v-slot:item.status="{ item }">
                              <div v-if="item.status==1 ">

                                <v-switch label="" @click="updatebusinesscourse(item,0)"  v-model="item.status" color="success"></v-switch>
                              </div>
                              <div v-else>

                                <v-switch label="" @click="updatebusinesscourse(item,1)"  v-model="item.status" color="success"></v-switch>
                              </div>

                            </template>

                            <template v-slot:item.image="{ item }">
                              <v-avatar @click="editItem(item)" class="eHover">
                                <img :src="item.image" :alt="item.name" />
                              </v-avatar>
                            </template>

                            <template v-slot:item.action="{ item }">
                                <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                                <v-icon small @click="deleteItem(item)">delete</v-icon>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

</template>
<script >
import Vue from 'vue'
export default {
    data: function(){return {
        search: "",
        headers: [
            { text: this.$i18n.t('zz_image'), value: "image", sortable: false },
            { text: this.$i18n.t('zz_name'), value: "name" },
            { text: this.$i18n.t('zz_items'), value: "items" },
            { text: this.$i18n.t('zz_status'), value: "status" },
            { text: this.$i18n.t('zz_created_at'), value: "created_at" },
            { text: this.$i18n.t('zz_actions'), value: "action", sortable: false }
        ],
        idtypes: [],
        business:[],
        business_id:0,
    }},
    created()
    {

        if(localStorage.getItem('business'))
        {
            this.business=JSON.parse(localStorage.getItem('business'));
            //fd.append('business_id',this.business['id']);
            this.business_id=this.business['id'];

        }
        else
        {


        }

      this.$http
      .get(this.$apidomain+"courselistpwa/"+this.business_id)
      .then(res => {
       this.idtypes = res.data.course;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    methods: {

    updatebusinesscourse(item,showstatus)
    {
        this.$http

      .post(this.$apidomain+"updatebusinesscoursestatus/"+item.id+'/'+item.business_id,{showstatus:showstatus})
      .then(res => {
        //this.businesses = res.data.businesses;
        // this.$router.push("/courselist");
        this.$http
        .get(this.$apidomain+"courselistpwa/"+this.business_id)
        .then(res => {
        this.idtypes = res.data.course;
        })
        .catch(err => {
          console.log(err.response);
        });
      })
      .catch(err => {
        console.log(err.response);
      });
    },

    editItem(item){
        //this.$router.push({name:'editcourse',params:{id:item.course_id}});
        this.$router.push({name:'editcourse',params:{id:item.id}});

    },
    deleteItem(item) {
        //alert(JSON.stringify(item));
      if (confirm("Are you sure you want to delete this Course?")) {
          this.$http
      //.post(this.$apidomain+"deleteCoursepwa/"+item.course_id+'/'+this.business_id)
      .post(this.$apidomain+"deleteCoursepwa/"+item.id+'/'+this.business_id)
      .then(res => {
        //this.businesses = res.data.businesses;
        // this.$router.push("/courselist");
        this.$http
        .get(this.$apidomain+"courselistpwa/"+this.business_id)
        .then(res => {
        this.idtypes = res.data.course;
        })
        .catch(err => {
          console.log(err.response);
        });
      })
      .catch(err => {
        console.log(err.response);
      });
      }
    },
    createagent(){
        this.$router.push('/createemployee');
    }
  }

}
</script>
